const AVAILABLE = 1;
const TEMPORARILY_UNAVAILABLE = 2;
const PERMANENTLY_UNAVAILABLE = 3;

module.exports = {
    AVAILABLE,
    TEMPORARILY_UNAVAILABLE,
    PERMANENTLY_UNAVAILABLE
}
